import { render } from "./App.vue?vue&type=template&id=30c3057e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=30c3057e&lang=scss"

import exportComponent from "/Users/richardpitul/Projects/booking-calendars/athletics-booking-calendar/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__